import {
  useQuery, UseQueryResult,
} from '@tanstack/react-query';
import { getGeofenceEventsReport } from '../../services/Reports';

function useGetGeofenceEventsReport(fleetId: string, query: string): UseQueryResult<any> {
  return useQuery(
    ['report-geofence-events', fleetId, query],
    async (): Promise<any> => getGeofenceEventsReport(fleetId, query),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: false,
      refetchInterval: false,
    },
  );
}

export default useGetGeofenceEventsReport;
